import React from 'react';

const Statistics = ({ data, year }) => {
  // Add a check to ensure data exists and is an array
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="statistics-panel">
        <h4>📊 Statistics for {year}</h4>
        <p className="no-data-message">No data available for this period</p>
      </div>
    );
  }

  // Safely compute statistics
  try {
    const values = data
      .map(d => d?.value)
      .filter(v => v !== null && v !== undefined && !isNaN(v));
    
    if (values.length === 0) {
      return (
        <div className="statistics-panel">
          <h4>📊 Statistics for {year}</h4>
          <p className="no-data-message">No valid data points</p>
        </div>
      );
    }

    const max = Math.max(...values);
    const min = Math.min(...values);
    const avg = values.reduce((a, b) => a + b, 0) / values.length;
    
    const positiveCount = values.filter(v => v > 0).length;
    const negativeCount = values.filter(v => v < 0).length;
    const zeroCount = values.filter(v => v === 0).length;

    return (
      <div className="statistics-panel">
        <h4>📊 Statistics for {year}</h4>
        <div className="stats-grid">
          <div className="stat-item">
            <span className="stat-label">Maximum:</span>
            <span className="stat-value" style={{color: '#2166ac'}}>
              {max.toFixed(2)} mGal
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Minimum:</span>
            <span className="stat-value" style={{color: '#b2182b'}}>
              {min.toFixed(2)} mGal
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Average:</span>
            <span className="stat-value">
              {avg.toFixed(2)} mGal
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Positive areas:</span>
            <span className="stat-value">
              {positiveCount} cells
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Negative areas:</span>
            <span className="stat-value">
              {negativeCount} cells
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Zero areas:</span>
            <span className="stat-value">
              {zeroCount} cells
            </span>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error('Error computing statistics:', error);
    return (
      <div className="statistics-panel">
        <h4>📊 Statistics for {year}</h4>
        <p className="error-message">Error computing statistics</p>
      </div>
    );
  }
};

export default Statistics;